'use client';

import { useEffect, useState } from 'react';

const TESTIMONIALS = [
  {
    quote:
      "I used to spend 3 hours setting up a single Meta campaign. With Strique I just describe what I want and it's live in 5 minutes. Our ROAS actually improved because the AI catches targeting details I'd miss.",
    name: 'Kayla Coleman',
    role: 'Ecommerce Founder · Sydney'
  },
  {
    quote:
      'I was paying separate people for my website, my social media, my ads, and my SEO. $5,000/month and nothing talked to each other. Strique replaced all of it.',
    name: 'Maria Santos',
    role: 'Bakery Owner · Miami'
  },
  {
    quote:
      'I used to spend my Sundays writing Instagram posts, tweaking my website, and trying to figure out Google ads. Now Strique does all of it and, honestly, does it better than I ever could.',
    name: 'David Park',
    role: 'Financial Advisor · Toronto'
  },
  {
    quote:
      "We were stuck at the same revenue for two years. Within 3 months of using Strique, our traffic tripled, our leads doubled, and we finally had to hire. That's a good problem to have.",
    name: 'Priya Sharma',
    role: 'Agency Owner · London'
  },
  {
    quote:
      "I've tried Canva, Wix, and Meta Ads Manager. I had a different tool for everything, and none of them grew my business. Strique actually connects all the dots and drives real results.",
    name: 'Marcus Rivera',
    role: 'Small Business Owner · Austin'
  }
];

export function TestimonialCarousel() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex((i) => (i + 1) % TESTIMONIALS.length);
        setVisible(true);
      }, 500);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // index is always within bounds (mod TESTIMONIALS.length), so the assertion is safe
  const testimonial = TESTIMONIALS[index]!;

  return (
    <div
      className="absolute top-16 -right-50 w-[400px] bg-white/90 backdrop-blur-md rounded-2xl px-4 py-4 shadow-md border border-white/60"
      style={{ opacity: visible ? 1 : 0, transition: 'opacity 0.5s ease' }}>
      <p className="text-[0.8125rem] text-gray-700 leading-[1.6] mb-3">
        &ldquo;{testimonial.quote}&rdquo;
      </p>
      <div className="flex items-center gap-2">
        <div className="w-6 h-6 rounded-full bg-violet-100 text-violet-700 text-[0.625rem] font-bold flex items-center justify-center shrink-0">
          {testimonial.name[0]}
        </div>
        <p className="m-0 text-[0.75rem] leading-[1.3]">
          <span className="font-semibold text-gray-900">{testimonial.name}</span>
          <span className="text-gray-400">, {testimonial.role}</span>
        </p>
      </div>
    </div>
  );
}
